import { type FC } from "react";

export type NumberValueProps = {
	children?: string;
};

export const NumberValue: FC<NumberValueProps> = ({ children }) => {
	return <span className="text-syntax-number">{children}</span>;
};
